import React from "react";

const ApplicationSkillsMatchtab = () => {
  return (
    <div className="flex items-center gap-12 px-16">
      <div className="w-2/5 flex flex-col text-center gap-8">
        <p className="bg-[#F1F5F9] text-primary rounded  text-xs font-semibold py-3 px-12 text-center">
          90% of skils matched for this job post
        </p>
        <p className="text-primary text-xs font-semibold">
          Skills view are set as confidential by Leslie
        </p>
      </div>
      <div className="flex w-3/5 flex-col border rounded-lg border-[#DDDDDD] py-3 px-6">
        <div className="flex justify-between border-b rounded-sm border-[#DDDDDD]  p-6">
          <div className="flex gap-4">
            <div className="font-montserrat text-white font-semibold uppercase w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center text-xl">
              SA
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-primary text-sm font-bold">Leslie Alexander</p>
              <p className="text-[#6F6F6F] text-xs text-semibold">
                Cyber Security Analyst
              </p>
              <p className="text-[#6F6F6F] text-xs text-semibold">
                Typically 4 hours
              </p>
            </div>
          </div>
          <div className="text-[#6F6F6F] text-xs text-semibold">CA-123BNM</div>
        </div>
        <div className="flex justify-between  rounded-sm border-[#DDDDDD]  p-6">
          <div className="flex px-16 items-center">
            <div className="items-center">
              <p className="text-primary text-sm font-bold mb-1">
                Leslie Alexander
              </p>
              <p className="text-[#2E2E2E] text-xs font-medium mb-1">
                Viewed by Leslie :{" "}
                <i className="font-normal text-[#6F6F6F]"> 14:08 1st June 25</i>
              </p>
            </div>
          </div>
          <div className="text-[#6F6F6F] text-xs text-semibold">MA-123BNM</div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSkillsMatchtab;
